import {MilestoneIcon, PersonIcon, TagIcon} from '@primer/octicons-react'
import type React from 'react'

import type {FieldIconName} from './fields'

type IconComponent = React.ComponentType<{size?: number}>

const iconMap: Record<FieldIconName, IconComponent> = {
  tag: TagIcon,
  milestone: MilestoneIcon,
  person: PersonIcon,
}

/** Resolve a field's icon identifier to its component. */
export function getFieldIcon(name: FieldIconName): IconComponent {
  return iconMap[name]
}
